import {
  createFileRoute,
  Outlet,
  Link,
  useLocation,
} from '@tanstack/react-router';
import { User, Wallet, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/pet/src/context/ThemeContext';

export const Route = createFileRoute('/dashboard/settings')({
  component: SettingsLayout,
});

function SettingsLayout() {
  const { colors } = useTheme();
  const location = useLocation();
  const { t } = useTranslation();

  const tabs = [
    {
      id: 'profile',
      path: '/dashboard/settings',
      labelKey: 'settings.tabs.profile',
      icon: User,
    },
    {
      id: 'wallet',
      path: '/dashboard/settings/wallet',
      labelKey: 'settings.tabs.wallet',
      icon: Wallet,
    },
    {
      id: 'security',
      path: '/dashboard/settings/security',
      labelKey: 'settings.tabs.security',
      icon: Shield,
    },
  ];

  const isActive = (path: string) => {
    if (path === '/dashboard/settings') {
      return (
        location.pathname === '/dashboard/settings' ||
        location.pathname === '/dashboard/settings/'
      );
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-2xl mb-1 text-[#2D2F7E] dark:text-white">
          {t('settings.title')}
        </h2>
        <p className="text-gray-600 dark:text-white/70">
          {t('settings.subtitle')}
        </p>
      </div>

      {/* Tabs Navigation */}
      <div
        className="flex gap-1 p-1 rounded-xl"
        style={{ backgroundColor: colors.surfaceHover }}
      >
        {tabs.map((tab) => {
          const active = isActive(tab.path);
          return (
            <Link
              key={tab.id}
              to={tab.path}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg transition-all"
              style={{
                backgroundColor: active ? colors.surface : 'transparent',
                color: active ? colors.primary : colors.textSecondary,
                boxShadow: active ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                fontFamily: 'Sora, sans-serif',
                fontWeight: active ? 600 : 400,
              }}
            >
              <tab.icon className="w-4 h-4" />
              <span className="text-sm">{t(tab.labelKey)}</span>
            </Link>
          );
        })}
      </div>

      {/* Page Content */}
      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
}
